<template>
  <validation-observer ref="register" slim>
    <form @submit.prevent="createCustomer()">
      <section class="passengerInformation passwordUpdate">
        <loading :active.sync="loadingFullPage" :is-full-page="true" />
        <div class="row">
          <!-- passenger -->
          <div class="col-12">
            <!-- gender -->
            <div class="row">
              <div class="col-12 mb-2">
                <div class="btn-group btn-group-toggle radioBtnGroup" data-toggle="buttons">
                  <label class="btn btn-secondary active" selenium-test="M">
                    <input v-model="selectedUser.user.gender" type="radio" name="gender1" :value="'M'" />
                    {{ $t("user-register-man") }}
                  </label>
                  <label class="btn btn-secondary" selenium-test="F">
                    <input v-model="selectedUser.user.gender" type="radio" name="gender1" :value="'F'" />
                    {{ $t("user-register-woman") }}
                  </label>
                </div>
              </div>
              <div class="col-6">
                <base-input
                  v-model="selectedUser.user.firstName"
                  :name="$t('user-register-name-2')"
                  :input-label-text="$t('user-register-name-2')"
                  :required-star="true"
                  :custom-messages="{ required: $t('user-register-input-null-validation-message'), regex: $t('user-register-name-field-is-not-valid') }"
                  :rules="{ required: true, regex: /^[a-zA-Z0-9\u00C0-\u024F\s.\-']+$/ }"
                  @input.native="upperCaseLetter('firstName', selectedUser.user.firstName)"
                />
              </div>
              <div class="col-6">
                <base-input
                  v-model="selectedUser.user.lastName"
                  :name="$t('user-register-surname')"
                  :input-label-text="$t('user-register-surname')"
                  :required-star="true"
                  :custom-messages="{ required: $t('user-register-input-null-validation-message'), regex: $t('user-register-surname-field-is-not-valid') }"
                  :rules="{ required: true, regex: /^[a-zA-Z0-9\u00C0-\u024F\s.\-']+$/ }"
                  @input.native="upperCaseLetter('lastName', selectedUser.user.lastName)"
                />
              </div>
              <div class="col-12">
                <base-input
                  v-model="selectedUser.user.email"
                  :name="$t('user-register-email')"
                  :input-label-text="$t('user-register-email')"
                  :custom-messages="{
                    required: $t('user-register-input-null-validation-message'),
                    regex: $t('user-register-please-enter-in-appropriate-format'),
                  }"
                  :required-star="true"
                  :rules="{ required: true, regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ }"
                />
              </div>
              <!--<div class="col-6">-->
              <!--  <validation-provider-->
              <!--    ref="passwordValid"-->
              <!--    :custom-messages="{ required: 'Doldurulması zorunlu alandır' }"-->
              <!--    :rules="{ required: true }"-->
              <!--    v-slot="validationContext"-->
              <!--    slim-->
              <!--  >-->
              <!--    <div class="form-group" :class="[validationContext.errors.length > 0 ? 'error' : null]">-->
              <!--      <label>Şifre</label>-->
              <!--      <span>*</span>-->
              <!--      <div class="inputPassword">-->
              <!--        <input-->
              <!--          @keyup="includeOneUpperCase(), includeOneLowerCase(), includeOneNumber(), minPasswordCharacterSuccess(), passwordStrength()"-->
              <!--          @focusout="-->
              <!--            notIncludeOneLowerCase(), notIncludeOneNumber(), notIncludeOneUpperCase(), minPasswordCharacterDanger(), checkPasswordRules()-->
              <!--          "-->
              <!--          selenium-test="password"-->
              <!--          :class="[validationContext.errors.length > 0 ? 'is-invalid' : null]"-->
              <!--          class="form-control"-->
              <!--          type="password"-->
              <!--          v-model="inputPassword"-->
              <!--        />-->
              <!--        <span :class="passwordLevel" v-if="inputPassword !== ''">{{ passwordStrong }}</span>-->
              <!--      </div>-->
              <!--      <div class="invalid-feedback-inline" v-show="validationContext.errors.length > 0">-->
              <!--        {{ validationContext.errors[0] ? validationTextFormat(validationContext.errors[0]) + "." : null }}-->
              <!--      </div>-->
              <!--    </div>-->
              <!--  </validation-provider>-->
              <!--</div>-->
              <!--<div class="col-6">-->
              <!--  <validation-provider-->
              <!--    ref="passwordValidAgain"-->
              <!--    :custom-messages="{ required: 'Doldurulması zorunlu alandır' }"-->
              <!--    :rules="{ required: true }"-->
              <!--    v-slot="validationContext"-->
              <!--    slim-->
              <!--  >-->
              <!--    <div class="form-group" :class="[validationContext.errors.length > 0 ? 'error' : null]">-->
              <!--      <label>Şifre (Tekrar)</label>-->
              <!--      <span>*</span>-->
              <!--      <div class="inputPassword">-->
              <!--        <input-->
              <!--          class="form-control"-->
              <!--          selenium-test="repassword"-->
              <!--          type="password"-->
              <!--          v-model="reInputPassword"-->
              <!--          :class="[validationContext.errors.length > 0 ? 'is-invalid' : null]"-->
              <!--        />-->
              <!--      </div>-->
              <!--      <div class="invalid-feedback-inline" v-show="validationContext.errors.length > 0">-->
              <!--        {{ validationContext.errors[0] ? validationTextFormat(validationContext.errors[0]) + "." : null }}-->
              <!--      </div>-->
              <!--    </div>-->
              <!--  </validation-provider>-->
              <!--</div>-->
              <!--password rules-->
              <!--<div class="col-12 passengersRules my-2">-->
              <!--  <h6 class="passwordRulesHead">Şifre oluşturma kuralları</h6>-->
              <!--  <ul>-->
              <!--    <li>-->
              <!--      <span :class="[successCharacter, dangerCharacter]"></span>-->
              <!--      Şifreniz en az 8 karakterden oluşmalıdır.-->
              <!--    </li>-->
              <!--    <li>-->
              <!--      <span :class="[successUpperCase, dangerUpperCase]"></span>-->
              <!--      Bir büyük harf içermelidir.-->
              <!--    </li>-->
              <!--    <li>-->
              <!--      <span :class="[successLowerCase, dangerLowerCase]"></span>-->
              <!--      Bir küçük harf içermelidir.-->
              <!--    </li>-->
              <!--    <li>-->
              <!--      <span :class="[successNumberCase, dangerNumberCase]"></span>-->
              <!--      En az bir rakam içermelidir.-->
              <!--    </li>-->
              <!--  </ul>-->
              <!--</div>-->
              <div class="col-6">
                <div class="form-group mb-0">
                  <label class="invisible">hidden</label>
                </div>
                <div class="form-group form-check pl-0 userRegisterPassengerCheckBox" data-toggle="buttons">
                  <label class="checkboxArea mb-0 btn">
                    <!--                            <span v-if="passenger.isAForeignNational" class="checkboxText">T.C.vatandaşıyım</span>-->
                    <span class="checkboxText">{{ $t("user-register-not-tc-passenger") }}</span>
                    <input type="checkbox" :checked="!isTurkish && selectedUser.user.nationalityCountryId !== 1" @click="nationalityChanged($event)" />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>

              <!--  -->
              <div v-show="isTurkish" class="col-6">
                <base-input
                  :id="'isTurkish'"
                  ref="citizenshipNo"
                  v-model="selectedUser.user.citizenshipNo"
                  v-mask="'###########'"
                  :input-label-text="$t('user-register-tck-no')"
                  :required-star="isTurkish"
                  :rules="isTurkishIdentityRequired()"
                  :custom-messages="ifTurkishIdentityIsRequiredShowErrorMessage()"
                  :disabled="!isTurkish"
                />
              </div>
              <!--  -->
              <!--required:isTurkish-->
              <div v-show="!isTurkish" class="col-6">
                <base-input
                  :id="'isPassport'"
                  ref="passportNo"
                  v-model="selectedUser.user.passportNo"
                  v-mask="'NNNNNNNNNNN'"
                  :input-label-text="$t('user-register-passport-no')"
                  :form-group-class="'passportNoField'"
                  :required-star="!isTurkish"
                  :rules="isPasaportNoRequired()"
                  :custom-messages="ifPasaportNoIsRequiredShowErrorMessage()"
                  :disabled="isTurkish"
                  :input-class="isTurkish ? 'disabled' : null"
                  @input.native="regexControl('passportNo', $event)"
                />
              </div>
              <div class="col-12 col-md-6">
                <validation-provider
                  ref="userRegisterBirthDateRef"
                  v-slot="validationContext"
                  :name="'DogumTarihi'"
                  :value="selectedUser.user.birthdate"
                  :custom-messages="{
                    required: $t('user-register-input-null-validation-message'),
                    regex: $t('user-register-please-enter-in-appropriate-format'),
                  }"
                  :rules="{ required: true, regex: birthDateRegex }"
                  slim
                >
                  <div class="form-group inputDateArea" :class="[validationContext.errors.length > 0 ? 'error' : null]">
                    <label>
                      {{ $t("user-register-birth-date") }}
                      <span class="text-danger">*</span>
                    </label>

                    <div v-if="isMobileDevice" class="d-flex align-items-center user-register-birthdate-wrapper">
                      <input
                        v-model="selectedUser.user.birthdate"
                        v-mask="'##.##.####'"
                        type="text"
                        inputmode="numeric"
                        lang="tr-TR"
                        class="form-control"
                        :placeholder="$t('day-month-year')"
                        maxlength="10"
                        :class="[
                          validationContext.errors.length > 0 ? 'is-invalid' : null,
                          validationContext.errors.length === 0 && selectedUser.user.birthdate ? 'is-valid' : null,
                        ]"
                        @input="handleUserRegisterBirthdateText"
                      />

                      <div class="date-icon-wrapper" @click="openUserRegisterBirthdatePicker">
                        <input
                          ref="userRegisterBirthdateNativeRef"
                          v-model="userRegisterBirthdateIsoLocal"
                          type="date"
                          lang="tr-TR"
                          class="date-hidden-input"
                          :max="new Date().toISOString().split('T')[0]"
                          @input="handleUserRegisterBirthdateNative"
                          @change="handleUserRegisterBirthdateNative"
                        />
                        <i class="fa fa-calendar"></i>
                      </div>
                    </div>

                    <input
                      v-else
                      v-model="userRegisterBirthdateIsoLocal"
                      type="date"
                      lang="tr-TR"
                      class="form-control"
                      :max="new Date().toISOString().split('T')[0]"
                      :class="[
                        validationContext.errors.length > 0 ? 'is-invalid' : null,
                        validationContext.errors.length === 0 && selectedUser.user.birthdate ? 'is-valid' : null,
                      ]"
                      @input="handleUserRegisterBirthdateNative"
                      @change="handleUserRegisterBirthdateNative"
                    />

                    <div v-if="validationContext.errors.length > 0" class="invalid-feedback-inline">
                      {{ validationContext.errors[0] ? validationTextFormat(validationContext.errors[0]) : null }}
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div v-show="isIndividualCustomer" class="col-12 col-md-6">
                <base-select
                  v-model="selectedUser.profession.id"
                  selenium-test="profession"
                  :label-text="$t('user-information-job')"
                  :options="professions"
                  :selected="selectedUser.profession.id"
                  :form-group-class="'formSelect'"
                  :text-field="'name'"
                  :value-field="'id'"
                  :data-live-search="true"
                  :rules="{ required: true }"
                  :required-star="true"
                  :custom-messages="{ required: $t('user-information-select-job') }"
                />
              </div>
              <div class="col-12">
                <div class="form-group">
                  <validation-provider
                    ref="inputPhoneNumberUserRegister"
                    v-slot="validationContext"
                    :custom-messages="{ required: $t('user-register-input-null-validation-message'), is: $t('appropriate-format'), min: $t('required-field') }"
                    :rules="nationalityList.length > 0 ? isPhoneNumberRequired() : null"
                    slim
                  >
                    <div class="form-group" :class="[phoneValidationTriggered && (!phoneInformation.isValid || validationContext.errors.length > 0) ? 'error' : null]">
                      <label for="inputText">
                        {{ $t("user-register-cellphone") }}
                        <span class="text-danger">*</span>
                      </label>
                      <vue-tel-input
                        v-bind="phoneInformation.phoneProps"
                        :ref="'telInputUserRegisterRef'"
                        v-model="phoneInformation.phoneNumber"
                        :dropdown-options="telInputDropdownOptions"
                        :input-options="phoneInformation.telInputOptions"
                        :valid-characters-only="true"
                        :style-classes="'customTelInput'"
                        :auto-format="true"
                        :class="[phoneValidationTriggered && (!phoneInformation.isValid || validationContext.errors.length > 0) ? 'is-invalid' : null]"
                        :default-country="phoneInformation.phoneNumberCountryObject.iso2"
                        @open="onDropdownOpen"
                        @input="inputRemoveZeroFromPhoneForPhoneNumber"
                        @validate="validatePhoneNumberForPhoneNumber"
                        @country-changed="countryChangedPhoneNumberForPhoneNumber"
                        @paste.native="handlePastePhoneNumberForPhoneNumber"
                      />
                      <div v-if="phoneValidationTriggered && (!phoneInformation.isValid || validationContext.errors.length > 0)" class="invalid-feedback-inline">
                        {{ phoneValidationTriggered && (!phoneInformation.isValid || validationContext.errors.length > 0) ? validationTextFormat(validationContext.errors[0]) : null }}
                      </div>
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="col-12">
                <hr class="mt-0" />
                <h5 class="cardBodySubTitle">{{ $t("user-register-communication-options") }}</h5>
                <p class="modalText">
                  {{ $t("user-register-p") }}
                  <a href="https://www.tcddtasimacilik.gov.tr/tr/kvkk_aydinlatma_metni" target="_blank">{{ $t("user-register-p-5") }}</a>
                  {{ $t("user-register-p-6") }}
                </p>
              </div>
              <!--  -->
              <!--              <div class="col-6">-->
              <!--                <base-select-->
              <!--                  selenium-test="city"-->
              <!--                  :label-text="'İl'"-->
              <!--                  :options="cities"-->
              <!--                  :selected="selectedUser.cityId"-->
              <!--                  :form-group-class="'formSelect mb-0'"-->
              <!--                  v-model="selectedUser.cityId"-->
              <!--                  :text-field="'name'"-->
              <!--                  :value-field="'id'"-->
              <!--                  :data-live-search="true"-->
              <!--                  @change.native="changeCity($event)"-->
              <!--                  :rules="{ required: true }"-->
              <!--                  :required-star="true"-->
              <!--                ></base-select>-->
              <!--              </div>-->
              <!--              <div class="col-6">-->
              <!--                <base-select-->
              <!--                  :ref="'districtSelect'"-->
              <!--                  selenium-test="district"-->
              <!--                  :label-text="'İlçe'"-->
              <!--                  :options="districts"-->
              <!--                  :selected="selectedUser.districtId"-->
              <!--                  :form-group-class="'formSelect mb-0'"-->
              <!--                  v-model="selectedUser.districtId"-->
              <!--                  :text-field="'name'"-->
              <!--                  :value-field="'id'"-->
              <!--                  :data-live-search="true"-->
              <!--                  @change.native="changeDistrict($event)"-->
              <!--                  :disabled="!selectedUser.cityId"-->
              <!--                  :rules="{ required: true }"-->
              <!--                  :required-star="true"-->
              <!--                ></base-select>-->
              <!--              </div>-->
              <!--              <div class="col-12">-->
              <!--                <base-select-->
              <!--                  :label-text="'Mahalle'"-->
              <!--                  :options="neighbourhoods"-->
              <!--                  :selected="selectedUser.neighbourhoodId"-->
              <!--                  v-model.number="selectedUser.neighbourhoodId"-->
              <!--                  :text-field="'name'"-->
              <!--                  :value-field="'id'"-->
              <!--                  :form-group-class="'formSelect mb-0'"-->
              <!--                  :data-size="5"-->
              <!--                  :data-live-search="true"-->
              <!--                  :disabled="!selectedUser.districtId"-->
              <!--                  :rules="{ required: true }"-->
              <!--                  :required-star="true"-->
              <!--                ></base-select>-->
              <!--              </div>-->
              <!--              <validation-provider ref="topicExplanation" :custom-messages="{ required: 'Doldurulması zorunlu alandır' }"-->
              <!--                                   :rules="{ required: true }" v-slot="validationContext" slim>-->
              <!--              <div class="col-12">-->
              <!--                <div class="form-group">-->
              <!--                  <label>-->
              <!--                    Açık Adres-->
              <!--                    <span>*</span>-->
              <!--                  </label>-->
              <!--                  <textarea-->
              <!--                    class="form-control"-->
              <!--                    selenium-test="address"-->
              <!--                    v-model="selectedUser.address"-->
              <!--                    rows="2"-->
              <!--                    :minlength="25"-->
              <!--                    :class="[validationContext.errors.length > 0 ? 'is-invalid' : null]"-->
              <!--                  ></textarea>-->
              <!--                  <div class="invalid-feedback-inline" v-if="validationContext.errors.length > 0">-->
              <!--                    {{ validationContext.errors[0] ? validationTextFormat(validationContext.errors[0]) + "." : null }}</div>-->
              <!--                </div>-->
              <!--              </div>-->
              <!--              </validation-provider>-->

              <div class="col-12 mb-3">
                <div class="row">
                  <div class="col-6">
                    <div class="form-check pl-0 mb-0 d-inline-block">
                      <label class="checkboxArea">
                        <input type="checkbox" />
                        <span class="checkmark"></span>
                        <span class="checkboxText">{{ $t("user-register-email") }}</span>
                      </label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-check pl-0 mb-0 d-inline-block">
                      <label class="checkboxArea">
                        <input type="checkbox" />
                        <span class="checkmark"></span>
                        <span class="checkboxText">SMS</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 mb-3">
                <div class="form-check pl-0 mb-0 d-inline-block">
                  <label class="checkboxArea">
                    <input v-model="isContractApproved" type="checkbox" />
                    <span class="checkmark"></span>
                    <span class="checkboxText">
                      {{ $t("user-register-p-2") }}
                      <a href="https://www.tcddtasimacilik.gov.tr/tr/yolcu_tasima_kurallari" target="_blank">{{ $t("user-register-p-3") }}</a>
                      {{ $t("user-register-p-and") }}
                      <a href="https://www.tcddtasimacilik.gov.tr/tr/gizlilik_politikasi" target="_blank">{{ $t("user-register-p-7") }}</a>
                      {{ $t("user-register-p-4") }}
                    </span>
                  </label>
                </div>
              </div>
              <!--  -->
              <!--              <div class="col-12">-->
              <!--                <p class="textInfo">-->
              <!--                  (*) İşareti bulunmayan alanların doldurulması zorunlu olmayıp, doldurduğunuz takdirde sizinle olan iletişimimiz daha kolay olacaktır.-->
              <!--                </p>-->
              <!--              </div>-->
            </div>
          </div>
        </div>
        <!-- user information end -->
      </section>
      <div class="row justify-content-center">
        <div class="col-auto">
          <button class="btn btnSign d-flex justify-content-center align-items-center" selenium-test="submit" :type="'submit'" :disabled="!isContractApproved">
            {{ $t("user-register-sign-up") }}
          </button>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col">
          <p class="modalText my-2 text-center">{{ $t("user-register-already-a-member") }}</p>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-auto text-center">
          <button type="button" class="btn btn-link p-0 border-0" @click="openMemberLogin()">{{ $t("user-register-login") }}</button>
        </div>
      </div>
      <base-alert />
    </form>
  </validation-observer>
</template>

<script>
import moment from "moment";
import zxcvbn from "zxcvbn";
import BaseAlert from "../element/BaseAlert.vue";
import ServiceResponseHelper from "../../mixins/serviceResponseHelper";
import Vue from "vue";
import Loading from "vue-loading-overlay";
import BaseInput from "../element/form/input/BaseInput.vue";
import BaseSelect from "../element/BaseSelect.vue";
import phoneMixin from "../../mixins/phoneMixin";

const VueTelInput = () =>
  Promise.all([
    import(/* webpackChunkName: "chunk-vue-tel-input" */ "vue-tel-input"),
    import(/* webpackChunkName: "chunk-vue-tel-input" */ "vue-tel-input/dist/vue-tel-input.css"),
  ]).then(([{ VueTelInput }]) => VueTelInput);

export default {
  name: "UserRegisterComponent",
  components: { BaseInput, BaseSelect, BaseAlert, Loading, VueTelInput },
  mixins: [ServiceResponseHelper, phoneMixin],
  data() {
    return {
      userInformation: { crmMusteriDVO: {} },
      inputFormsValid: false,
      reInputPassword: null,
      inputPassword: null,
      passwordMinCharacter: 8,
      dangerUpperCase: null,
      dangerLowerCase: null,
      dangerNumberCase: null,
      dangerCharacter: null,
      successUpperCase: null,
      successLowerCase: null,
      successNumberCase: null,
      successCharacter: null,
      passwordValid: false,
      passwordLevel: null,
      passwordStrong: null,
      isValidBirthDate: false,
      birthDate: null,
      isValidEposta: null,
      isValidPassword: null,
      nationalities: [],
      selectedNationality: null,
      searchNationality: "",
      filteredNationalities: [],
      selectedNationalList: [],
      searchCity: "",
      selectedCity: null,
      selectedDistrict: null,
      searchDistrict: null,
      filteredDistricts: [],
      filteredCities: [],
      tckNoValid: true,
      isValidPasaportNo: true,
      user: {
        cinsiyet: "M",
        firstName: null,
        lastName: null,
        password: "",
        email: "",
        dogumTar: null,
        tckn: null,
        pasaportNo: null,
        cepTelNo: null,
        ilId: null,
        ilceId: null,
        adres: null,
        phoneInformation: {
          phoneNumber: "",
        },
      },
      createLoading: false,
      statusTypeOptions: [
        { name: this.$t("activation"), id: "ACTIVE", disabled: false, hidden: false },
        { name: this.$t("disarming"), id: "PASSIVE", disabled: false, hidden: false },
      ],
      // image
      maxFileSize: 5242880, // 5 mb
      itemImage: null,
      uploadImageFlag: false,
      // tel input start
      telInputDropdownOptions: {
        showSearchBox: true,
        showFlags: true,
        showDialCodeInList: true,
        tabindex: 0,
        width: "100%",
        showDialCodeInSelection: true,
      },
      phoneInformation: {
        countryCode: "",
        phoneNumber: "",
        isValid: true,
        props: {
          preferredCountries: ["TR"],
        },
        phoneNumberCountryObject: {
          name: "Turkey (Türkiye)",
          iso2: "TR",
          dialCode: "90",
        },
        telInputOptions: {
          autocomplete: "on",
          autofocus: false,
          "aria-describedby": "telephone-input",
          maxlength: 15,
          name: "telephone",
          tabindex: 0,
          type: "tel",
        },
      },

      phoneInformationStatusForPhoneNumber: false,
      // Telefon "zorunlu/gecersiz" uyarisi yalnizca Kayit Ol'a basildiktan sonra gosterilir
      // (ilk acilista dokunulmamis alanda kirmizi cikmasin). Modal acilisinda false'a cekilir.
      phoneValidationTriggered: false,
      // tel input end
      birthDateMask: "##/##/####",
      selectedStatus: "PASSIVE",
      isIndividualCustomer: true,
      nationalityList: [],
      loadingCities: false,
      loadingNationalities: false,
      loadingDistricts: false,
      loadingBloodTypes: false,
      loadingNeighbourhoods: false,
      loadingProfessions: false,
      loadingEducationStatuses: false,
      loadingTaxAdministrations: false,
      loadingResetPassword: false,
      emailRequired: true,
      cities: [],
      districts: [],
      neighbourhoods: [],
      bloodTypes: [],
      professions: [],
      educationStatuses: [],
      taxAdministrations: [],
      selectedStatusReason: null,
      statusReasonDescription: null,
      customerLogs: [],
      saveButtonIsClick: false,
      isTurkish: true,
      phoneNumberIsValid: true,
      isContractApproved: false,
      loadingCheckMernis: false,
      isMobileDevice: false,
      userRegisterBirthdateIsoLocal: "",
      // Hem DD.MM.YYYY hem de (native input'tan gelebilecek) YYYY-MM-DD formatını kabul eder (yıl: 19xx/20xx)
      birthDateRegex: /^((19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])|(0[1-9]|[12]\d|3[01])\.(0[1-9]|1[0-2])\.(19|20)\d{2})$/,
      isMobileDropdownMenu: false,
    };
  },
  computed: {
    selectedLanguage: {
      get() {
        return this.$store.getters.getLanguage;
      },
    },
    loadingFullPage() {
      return (
        this.loadingResetPassword ||
        this.loadingCities ||
        this.loadingNationalities ||
        this.loadingDistricts ||
        this.loadingBloodTypes ||
        this.loadingNeighbourhoods ||
        this.loadingProfessions ||
        this.loadingEducationStatuses ||
        this.loadingTaxAdministrations ||
        this.createLoading ||
        this.loadingCheckMernis
      );
    },
    selectedUser: {
      get() {
        return this.$store.getters.getSelectedUser;
      },
      set(val) {
        this.$store.commit("setSelectedUser", val);
      },
    },
    isThisAnUpdateCustomer: {
      get() {
        return this.$store.getters.getIsThisAnUpdateCustomer;
      },
      set(val) {
        this.$store.commit("setIsThisAnUpdateCustomer", val);
      },
    },
  },
  watch: {
    itemImage: {
      handler(val) {
        this.imageUpload();
      },
      deep: true,
    },
    "selectedUser.user.birthdate": {
      handler(val) {
        // Store'daki DD.MM.YYYY değeri ISO input'a yansısın
        if (!val) {
          this.userRegisterBirthdateIsoLocal = "";
          return;
        }
        const m = moment(val, "DD.MM.YYYY", true);
        this.userRegisterBirthdateIsoLocal = m.isValid() ? m.format("YYYY-MM-DD") : this.userRegisterBirthdateIsoLocal;
      },
      immediate: true,
    },
  },
  // beforeRouteLeave(to, from, next) {
  //   if(this.isThisAnUpdateCustomer){
  //     if (this.saveButtonIsClick) {
  //       this.resetCustomer();
  //       next();
  //       return;
  //     }
  //     if (Object.keys(this.$store.getters.getUser).length <= 0){
  //       this.resetCustomer();
  //       next();
  //       return;
  //     }
  //     const h = this.$createElement;
  //     // content
  //     const messageVNode = h("div", { class: ["row justify-content-center mt-5"] }, [
  //       h("div", { class: ["col-12"] }, [
  //         h("b-img", {
  //           props: {
  //             // src: require("../../images/icon-modal-warning.svg"),
  //             center: true,
  //           },
  //         }),
  //         h("h3", { class: ["bodyTitle text-center mt-3"], domProps: { innerHTML: "UYARI !" } }),
  //       ]),
  //       // body dynamic content
  //       h("div", { class: ["col-12"] }, [h("p",{ class: ["text-center"] }, ['Kaydedilmemiş verileriniz var.Sayfadan çıkmaya emin misiniz?'])]),
  //     ]);
  //
  //     this.$bvModal.msgBoxConfirm([messageVNode], {
  //       size: "md",
  //       buttonSize: "md",
  //       cancelTitle: "Hayır",
  //
  //       modalClass: "seferModal modalWarning messageBoxModal",
  //       title: "",
  //       okVariant: "primary",
  //       okTitle: "Evet",
  //       hideHeaderClose: false,
  //       centered: true,
  //       hideBackdrop: true,
  //       headerCloseContent: "",
  //       headerClass: 'p-2 border-bottom-0',
  //       footerClass: 'p-3 pb-0 border-top-0 mb-4',
  //     })
  //         .then(value => {
  //           if (value) {
  //             this.resetCustomer();
  //             next();
  //           } else {
  //             next(false);
  //           }
  //         })
  //         .catch(err => {
  //           console.log(err);
  //         });
  //   }else{
  //     next();
  //   }
  // },
  mounted() {
    this.checkMobileDevice();
    window.addEventListener("resize", this.checkMobileDevice);
    this.checkMobileDropdownMenu();
    window.addEventListener("resize", this.checkMobileDropdownMenu);
    // Register modal her acildiginda (register()/goRegister() vb. hangi yoldan olursa olsun) telefon
    // "zorunlu/gecersiz" uyarisini sifirla; ilk acilista dokunulmamis alanda kirmizi cikmasin.
    $("#newUser").on("show.bs.modal", () => {
      this.phoneValidationTriggered = false;
    });
    if (!this.isThisAnUpdateCustomer) {
      // this.resetCustomer();
      this.selectedUser.user.gender = "M";
    } else {
      if (!this.isThisAnUpdateCustomer) {
        return (this.selectedUser = {
          bloodType: {},
          profession: { id: "" },
          user: { taxAdministration: {} },
          educationStatus: {},
        });
      }
      // il,ilçe,mahalle data da olduğu için ve il seçildikten sonra ilçe listesi dolduğu için tekrar istek atılıyor.
      const cityId = this.selectedUser.cityId;
      const districtId = this.selectedUser.districtId;
      const neighbourhoodId = this.selectedUser.neighbourhoodId;
      this.changeCity({ target: { value: this.selectedUser.cityId } });
      this.changeDistrict({ target: { value: districtId } });
      this.$nextTick(() => {
        this.selectedUser.cityId = cityId;
        this.selectedUser.districtId = districtId;
        this.selectedUser.neighbourhoodId = neighbourhoodId;
      });
      // il,ilçe,mahalle data da olduğu için ve il seçildikten sonra ilçe listesi dolduğu için tekrar istek atılıyor.
      // v-mask içini boşaltıyoruz date setlendikten sonra v-mask ekliyoruz.
      this.birthDateMask = "";
      this.$nextTick(() => {
        this.selectedUser.user.birthdate = moment(this.selectedUser.user.birthdate).format("DD.MM.YYYY");
        this.$nextTick(() => {
          this.birthDateMask = "##/##/####";
        });
      });
      this.phoneInformation.phoneNumber = this.selectedUser.user.mobileNumber;
      this.itemImage = this.selectedUser.image;
      this.selectedStatus = this.selectedUser.user.status;
      this.statusReasonDescription = this.selectedUser.user.statusReasonDescription;
      this.selectedStatusReason = this.selectedUser.user.statusReason.id;
    }
    if (this.selectedUser.user.nationalityCountryId === 1) {
      this.isTurkish = true;
    }
    $(".selectpicker").selectpicker("refresh");
    this.checkTelInputRef();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobileDevice);
    window.removeEventListener("resize", this.checkMobileDropdownMenu);
  },
  created() {
    this.loadingNationalities = true;
    this.$store
      .dispatch("loadNationalities")
      .then((response) => {
        this.nationalityList = response;
        this.$store.commit("setAllNationalityList", response);
      })
      .finally(() => {
        this.loadingNationalities = false;
        if (!this.isThisAnUpdateCustomer) {
          this.selectedUser.user.nationalityCountryId = 1;
          this.isTurkish = true;
        }
        $(".selectpicker").selectpicker("refresh");
      });

    this.loadingProfessions = true;
    this.$store
      .dispatch("loadProfessions")
      .then((response) => {
        this.professions = response;
      })
      .finally(() => {
        this.loadingProfessions = false;
        $(".selectpicker").selectpicker("refresh");
      });

    if (this.selectedUser.user.companyName && this.selectedUser.user.companyName.length > 0) {
      this.isIndividualCustomer = false;
    } else {
      this.isIndividualCustomer = true;
    }
  },
  methods: {
    checkMobileDevice() {
      this.isMobileDevice = window.innerWidth < 767;
    },
    openUserRegisterBirthdatePicker() {
      const el = this.$refs.userRegisterBirthdateNativeRef;
      const input = Array.isArray(el) ? el[0] : el;
      if (!input) return;

      // Chromium: showPicker var, Safari/FF: fallback click/focus.
      try {
        if (typeof input.showPicker === "function") {
          input.showPicker();
          return;
        }
      } catch (e) {
        // ignore
      }
      input.focus();
      input.click();
    },
    validateUserRegisterBirthdate() {
      this.$nextTick(() => {
        this.$nextTick(() => {
          const ref = this.$refs.userRegisterBirthDateRef;
          const provider = Array.isArray(ref) ? ref[0] : ref;
          if (!provider || typeof provider.validate !== "function") return;

          const raw = (this.selectedUser?.user?.birthdate ?? "").toString();
          const val = this.sanitizeBirthdateForValidation(raw);

          // Kullanıcı girişini bozmayalım; sadece tam tarih oluştuysa normalize edip yazalım.
          if (this.birthDateRegex.test(val) || val === "") {
            this.selectedUser.user.birthdate = val;
          }
          provider.validate(val);
        });
      });
    },
    sanitizeBirthdateForValidation(value) {
      if (!value) return "";
      const trimmed = value.toString().trim();

      // ISO -> DD.MM.YYYY
      if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
        const m = moment(trimmed, "YYYY-MM-DD", true);
        return m.isValid() ? m.format("DD.MM.YYYY") : "";
      }

      // Her türlü görünmez/ayraç karakterini temizle, 8 rakamdan DD.MM.YYYY üret
      const digits = trimmed.replace(/\D/g, "");
      if (digits.length === 8) {
        const dd = digits.slice(0, 2);
        const mm = digits.slice(2, 4);
        const yyyy = digits.slice(4, 8);
        return `${dd}.${mm}.${yyyy}`;
      }

      // Kısmi girişlerde mevcut değeri mümkün olduğunca sadeleştir
      return trimmed
        .replace(/[^\d./-]/g, "")
        .replace(/\//g, ".")
        .replace(/-/g, ".")
        .replace(/\s+/g, "");
    },
    normalizeBirthdateToDdMmYyyy(value) {
      if (!value) return "";
      const trimmed = value.toString().trim();

      // ISO -> DD.MM.YYYY
      if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
        const m = moment(trimmed, "YYYY-MM-DD", true);
        return m.isValid() ? m.format("DD.MM.YYYY") : "";
      }

      // DD.MM.YYYY already (but normalize any non-standard separators/chars)
      const digits = trimmed.replace(/\D/g, "");
      if (digits.length === 8) {
        const dd = digits.slice(0, 2);
        const mm = digits.slice(2, 4);
        const yyyy = digits.slice(4, 8);
        return `${dd}.${mm}.${yyyy}`;
      }
      return trimmed.replace(/\//g, ".").replace(/\s+/g, "");
    },
    handleUserRegisterBirthdateText() {
      this.selectedUser.user.birthdate = this.sanitizeBirthdateForValidation(this.selectedUser.user.birthdate);
      this.validateUserRegisterBirthdate();
    },
    handleUserRegisterBirthdateNative(event) {
      const iso = event?.target?.value ?? this.userRegisterBirthdateIsoLocal;
      if (!iso) {
        this.selectedUser.user.birthdate = "";
        this.validateUserRegisterBirthdate();
        return;
      }

      const m = moment(iso, "YYYY-MM-DD", true);
      if (m.isValid()) {
        this.selectedUser.user.birthdate = m.format("DD.MM.YYYY");
        this.userRegisterBirthdateIsoLocal = iso;
      }
      this.validateUserRegisterBirthdate();
    },
    upperCaseLetter(value, letter) {
      if (letter !== undefined) {
        this.selectedUser.user[value] = letter.toLocaleUpperCase("tr-TR");
      } else {
        return letter;
      }
    },
    isTurkishIdentityRequired() {
      if (this.isTurkish) {
        return { required: true, turkish_identity_number: true, min: 10, max: 11 };
      } else {
        return { required: false };
      }
    },
    ifTurkishIdentityIsRequiredShowErrorMessage() {
      if (this.isTurkish) {
        return { required: this.$t("payment-required-field"), turkish_identity_number: this.$t("user-register-check-tck-no-warning-2") };
      }
    },
    isPasaportNoRequired() {
      if (!this.isTurkish) {
        return { required: true, min: 5, max: 11 };
      } else {
        return { required: false };
      }
    },
    ifPasaportNoIsRequiredShowErrorMessage() {
      if (!this.isTurkish) {
        return {
          required: this.$t("required-field-v2"),
          min: this.$t("user-register-passport-no-length-warning"),
          max: this.$t("user-register-passport-no-length-warning-2"),
        };
      }
    },
    checkPasswordRules() {
      if (this.dangerUpperCase !== null || this.dangerLowerCase !== null || this.dangerCharacter !== null || this.dangerNumberCase !== null) {
        this.isValidPassword = false;
        if (this.inputPassword === "") {
          this.$refs.passwordValid.applyResult({
            errors: [this.$t("required-field-v2")],
            valid: false,
            failedRules: {},
          });
        } else {
          this.$refs.passwordValid.applyResult({
            errors: [""],
            valid: false,
            failedRules: {},
          });
        }
      } else {
        this.isValidPassword = true;
      }
    },
    passwordStrength() {
      if (zxcvbn(this.inputPassword).score <= 2) {
        this.passwordStrong = this.$t("user-register-validate-password-strength-message");
        return (this.passwordLevel = "text-danger");
      } else if (zxcvbn(this.inputPassword).score === 3) {
        this.passwordStrong = this.$t("user-register-validate-password-strength-message-2");
        return (this.passwordLevel = "text-warning");
      } else if (zxcvbn(this.inputPassword).score >= 4) {
        this.passwordStrong = this.$t("user-register-validate-password-strength-message-3");
        return (this.passwordLevel = "text-success");
      }
    },
    minPasswordCharacterSuccess() {
      if (this.inputPassword?.toString().length >= 8) {
        this.successCharacter = "bg-success";
        this.dangerCharacter = null;
      } else return (this.successCharacter = null);
    },
    includeOneUpperCase() {
      if (this.inputPassword?.match(/[A-ZİŞĞÇÖÜ]/g) !== null) {
        this.successUpperCase = "bg-success";
        this.dangerUpperCase = null;
      } else {
        return (this.successUpperCase = null);
      }
    },
    includeOneLowerCase() {
      if (this.inputPassword?.match(/[a-zışğçöü]/g) !== null) {
        this.successLowerCase = "bg-success";
        this.dangerLowerCase = null;
      } else {
        return (this.successLowerCase = null);
      }
    },
    includeOneNumber() {
      if (this.inputPassword?.match(/[0-9]/g) !== null) {
        this.successNumberCase = "bg-success";
        this.dangerNumberCase = null;
      } else {
        return (this.successNumberCase = null);
      }
    },
    minPasswordCharacterDanger() {
      if (this.inputPassword?.toString().length < 8) {
        return (this.dangerCharacter = "bg-danger");
      } else {
        return (this.dangerCharacter = null);
      }
    },
    notIncludeOneUpperCase() {
      if (this.inputPassword?.match(/[A-ZİŞĞÇÖÜ]/g) === null) {
        return (this.dangerUpperCase = "bg-danger");
      } else {
        return (this.dangerUpperCase = null);
      }
    },
    notIncludeOneLowerCase() {
      if (this.inputPassword?.match(/[a-zışğçöü]/g) === null) {
        return (this.dangerLowerCase = "bg-danger");
      } else {
        return (this.dangerLowerCase = null);
      }
    },
    notIncludeOneNumber() {
      if (this.inputPassword?.match(/[0-9]/g) === null) {
        return (this.dangerNumberCase = "bg-danger");
      } else {
        return (this.dangerNumberCase = null);
      }
    },
    cleanPhoneNumber(phoneNumber) {
      if (!phoneNumber) return "";
      return phoneNumber.toString().replace(/\D/g, "");
    },
    formatPhoneByPlaceholder(cleanNumber, placeholder) {
      if (!cleanNumber || !placeholder) return cleanNumber;

      let formatted = "";
      let numIndex = 0;

      for (let i = 0; i < placeholder.length && numIndex < cleanNumber.length; i++) {
        const char = placeholder.charAt(i);
        if (char === "_") {
          formatted += cleanNumber.charAt(numIndex++);
        } else {
          formatted += char;
        }
      }

      // Kalan rakamları ekle
      if (numIndex < cleanNumber.length) {
        formatted += cleanNumber.substring(numIndex);
      }

      return formatted;
    },
    calculateMaxLength(countryCode) {
      const format = this.countryPhoneFormats[countryCode];
      if (!format) return 15; // varsayılan

      const spaceCount = (format.placeholder.match(/\s/g) || []).length;
      const dashCount = (format.placeholder.match(/\-/g) || []).length;
      const parenCount = (format.placeholder.match(/[()]/g) || []).length;

      return format.maxLength + spaceCount + dashCount + parenCount;
    },
    formatUSTerritoryPhone(phoneNumber, countryCode) {
      const areaCode = this.usTerritoryCodes[countryCode];
      let cleanNumber = this.cleanPhoneNumber(phoneNumber);

      // Alan kodu varsa kaldır
      if (cleanNumber.startsWith(areaCode)) {
        cleanNumber = cleanNumber.substring(areaCode.length);
      }

      // 7 haneli format: xxx-xxxx
      if (cleanNumber.length >= 7) {
        cleanNumber = cleanNumber.substring(0, 7);
        return cleanNumber.replace(/(\d{3})(\d{4})/, "$1-$2");
      }

      return cleanNumber;
    },
    formatGBTerritoryPhone(phoneNumber, countryCode) {
      const areaCode = this.gbTerritoryCodes[countryCode];
      let cleanNumber = this.cleanPhoneNumber(phoneNumber);

      // Alan kodu varsa kaldır
      if (cleanNumber.startsWith(areaCode)) {
        cleanNumber = cleanNumber.substring(areaCode.length);
      }

      if (cleanNumber.length >= 10) {
        return cleanNumber.replace(/(\d{4})(\d{6})/, "$1 $2");
      }

      return cleanNumber;
    },
    countryChangedPhoneNumberForPhoneNumber(countryObject) {
      if (this.isManuallySettingCountry) return;

      if (this.isSettingPhoneFromMounted) return;

      this.phoneInformation.phoneNumberCountryObject = countryObject;
      this.phoneInformation.props.preferredCountries = [countryObject.iso2];
      this.$refs.telInputUserRegisterRef.activeCountryCode = countryObject.iso2;

      if (this.usTerritoryCodes[countryObject.iso2]) {
        const areaCode = this.usTerritoryCodes[countryObject.iso2];

        this.phoneInformation.telInputOptions.placeholder = this.countryPhoneFormats[countryObject.iso2]?.placeholder ?? "___ ___ __ __";
        const numberOfSpaces = (this.phoneInformation.telInputOptions.placeholder.match(/\s/g) || []).length;
        const dashCount = (this.phoneInformation.telInputOptions.placeholder.match(/\-/g) || []).length;
        this.phoneInformation.telInputOptions.maxlength = this.countryPhoneFormats[countryObject.iso2]?.maxLength + numberOfSpaces + dashCount ?? 7;

        let phoneNumber = this.phoneInformation.phoneNumber;
        if (phoneNumber) {
          phoneNumber = phoneNumber.replace(/[\s\-()]/g, "");

          if (phoneNumber.startsWith(areaCode)) {
            phoneNumber = phoneNumber.substring(areaCode.length);
          }

          if (phoneNumber.length >= 7) {
            phoneNumber = phoneNumber.substring(0, 7).replace(/(\d{3})(\d{4})/, "$1-$2");
          }

          this.phoneInformation.phoneNumber = phoneNumber;
        }
      } else if (this.isGBTerritory(countryObject.iso2)) {
        let phoneNumber = this.phoneInformation.phoneNumber;

        if (countryObject.iso2 in this.gbTerritoryCodes) {
          const areaCode = this.gbTerritoryCodes[countryObject.iso2];
          if (phoneNumber.startsWith(areaCode)) {
            phoneNumber = phoneNumber.slice(areaCode.length);
          }
        }

        phoneNumber = this.formatGBTerritoryPhone(phoneNumber, countryObject.iso2);
        const areaCode = this.gbTerritoryCodes[countryObject.iso2];
        let cleanPhoneNumber = phoneNumber.replace(/\D/g, "");

        if (cleanPhoneNumber.startsWith(areaCode) || cleanPhoneNumber.startsWith("0" + areaCode)) {
          if (cleanPhoneNumber.charAt(0) === "0") {
            cleanPhoneNumber = cleanPhoneNumber.slice(1);
          }
          cleanPhoneNumber = cleanPhoneNumber.substring(areaCode.length);
        }
        if (cleanPhoneNumber.charAt(0) === "0") {
          cleanPhoneNumber = cleanPhoneNumber.slice(1);
        }
        this.phoneInformation.phoneNumber = cleanPhoneNumber;
        this.phoneInformation.isValid = this.cleanPhoneNumber(phoneNumber).length >= 10;
        this.$refs.telInputUserRegisterRef.activeCountryCode = countryObject.iso2;

        this.$nextTick(() => {
          this.checkPhoneValidation();
        });
      } else {
        // Normal ülkeler için standart işlem
        this.phoneInformation.telInputOptions.placeholder = this.countryPhoneFormats[countryObject.iso2]?.placeholder ?? "___ ___ __ __";
        const numberOfSpaces = (this.phoneInformation.telInputOptions.placeholder.match(/\s/g) || []).length;
        const dashCount = (this.phoneInformation.telInputOptions.placeholder.match(/\-/g) || []).length;
        this.phoneInformation.telInputOptions.maxlength = this.countryPhoneFormats[countryObject.iso2]?.maxLength + numberOfSpaces + dashCount ?? 13;
      }

      // Ülke değişikliği sonrası validasyonu güncelle
      this.$nextTick(() => {
        this.checkPhoneValidation();
      });
    },
    validatePhoneNumberForPhoneNumber(object) {
      if (this.phoneInformationStatusForPhoneNumber) {
        // ABD teritorisi kontrolü
        const isUSTerritory = this.isUSTerritory(object?.countryCode);

        // ABD teritorileri için özel doğrulama mantığı
        if (isUSTerritory && object && object.nationalNumber) {
          this.phoneInformation.isValid = true;
          return true;
        }

        if (this.isGBTerritory(object?.countryCode)) {
          this.phoneInformation.isValid = object.nationalNumber.length >= 10;
          return this.phoneInformation.isValid;
        }

        if (
          !object ||
          (typeof object === "object" && !Object.keys(object).length) ||
          !object.countryCode ||
          (!object.valid && object.nationalNumber.length >= 8)
        ) {
          const countryCode = object.countryCode; // ISO ülke kodu (TR, US, GB vb.)
          const countryFormat = this.countryPhoneFormats[countryCode];
          if (countryCode === "TR") {
            // Türkiye için özel format
            let formattedNumber = object.formatted;

            // Başında +90 olan formatta mı
            if (formattedNumber.startsWith("+90")) {
              // Numaranın başında 0 olup olmadığını kontrol ediyoruz
              formattedNumber = formattedNumber.replace(/^\+90\s?0/, "+90 ");
            } else if (formattedNumber.startsWith("0")) {
              // Eğer başında 0 varsa ve öncesinde + vs. varsa kaldırıyoruz
              formattedNumber = formattedNumber.replace(/^0/, "");
            } else {
              formattedNumber = formattedNumber.replace(/^(\+?(\d{1,3})?)?\s*\(?0?(\d{3})\)?[\s\)]*(\d{3})[\s-]?(\d{2})[\s-]?(\d{2})$/, "$3 $4 $5 $6");
            }
            this.phoneInformation.phoneNumber = formattedNumber;
          } else if (countryFormat) {
            // Diğer ülkeler için placeholder'a göre format uygula
            let cleanNumber = object.nationalNumber.replace(/\D/g, "");
            let formattedNumber = "";

            // Formatlama için placeholder'ı kullan
            const placeholder = countryFormat.placeholder;
            let numIndex = 0;

            for (let i = 0; i < placeholder.length && numIndex < cleanNumber.length; i++) {
              const char = placeholder.charAt(i);

              if (char === "_") {
                // "_" yerine numarayı koy
                formattedNumber += cleanNumber.charAt(numIndex++);
              } else {
                // Boşluk veya özel karakter ise olduğu gibi ekle
                formattedNumber += char;
              }
            }

            // Eğer hala rakam kaldıysa kalan kısmı ekle
            if (numIndex < cleanNumber.length) {
              formattedNumber += cleanNumber.substring(numIndex);
            }
            this.$nextTick(() => {
              if (formattedNumber && formattedNumber.startsWith("0")) {
                // Eğer başında 0 varsa ve öncesinde + vs. varsa kaldırıyoruz
                formattedNumber = formattedNumber.replace(/^0/, "");
              }
              this.phoneInformation.phoneNumber = formattedNumber;
            });
          } else {
            let formattedNumber = object.nationalNumber;
            if (formattedNumber && formattedNumber.startsWith("0")) {
              // Eğer başında 0 varsa ve öncesinde + vs. varsa kaldırıyoruz
              formattedNumber = formattedNumber.replace(/^0/, "");
            }
            // Eğer ülke formatı tanımlı değilse, ulusal numarayı olduğu gibi kullan
            this.phoneInformation.phoneNumber = formattedNumber;
          }
        } else {
          // Ülkeye özel uzunluk kontrolü
          if (object && object.countryCode) {
            const countryFormat = this.countryPhoneFormats[object.countryCode];

            if (countryFormat && object.nationalNumber.length > countryFormat.maxLength) {
              // Maksimum uzunluğu aşarsa kırp
              object.nationalNumber = object.nationalNumber.slice(0, countryFormat.maxLength);
              object.formatted = object.formatted.slice(0, -1);
              object.number = object.number.slice(0, -1);
            } else if (object.countryCode === "TR" && object.nationalNumber.length >= 11) {
              // TR için özel kontrol (geriye dönük uyumluluk)
              object.nationalNumber = object.nationalNumber.slice(0, -1);
              object.formatted = object.formatted.slice(0, -1);
              object.number = object.number.slice(0, -1);
            }
          }
        }
        // Ayirac karakterler (bosluk, tire, parantez) haric sadece hane sayisi ulke formatiyla karsilastirilir.
        const phoneFormat = this.countryPhoneFormats[this.phoneInformation.phoneNumberCountryObject.iso2];
        const digitCount = this.cleanPhoneNumber(this.phoneInformation?.phoneNumber).length;
        this.phoneInformation.isValid = phoneFormat
          ? digitCount >= phoneFormat.minLength && digitCount <= phoneFormat.maxLength
          : digitCount >= 10;
      }
      this.phoneInformationStatusForPhoneNumber = true;
    },
    inputRemoveZeroFromPhoneForPhoneNumber(phoneObject) {
      // Manuel flag açıksa hiçbir işlem yapma
      if (this.isManuallySettingCountry) return;

      // Mounted flag açıksa hiçbir işlem yapma
      if (this.isSettingPhoneFromMounted) return;

      const event = phoneObject && phoneObject.target ? phoneObject : null;
      let phoneNumber = this.phoneInformation.phoneNumber;
      let countryCode = null;

      if (this.phoneInformation.phoneNumberCountryObject?.country?.iso2) {
        countryCode = this.phoneInformation.phoneNumberCountryObject.country.iso2;
      } else if (this.phoneInformation.phoneNumberCountryObject?.iso2) {
        countryCode = this.phoneInformation.phoneNumberCountryObject.iso2;
      }
      let currentPhoneNumberCountryObject = JSON.parse(JSON.stringify(this.phoneInformation.phoneNumberCountryObject));
      let currentPhoneNumber = this.phoneInformation.phoneNumber;

      if (this.fixedNumberProblemForUSTerritoriesForPhoneNumber(phoneNumber, countryCode)) return;

      if (this.isGBTerritory(countryCode)) {
        if (countryCode in this.gbTerritoryCodes) {
          const areaCode = this.gbTerritoryCodes[countryCode];
          if (phoneNumber.startsWith(areaCode)) {
            phoneNumber = phoneNumber.slice(areaCode.length);
          }
        }

        phoneNumber = this.formatGBTerritoryPhone(phoneNumber, countryCode);
        const areaCode = this.gbTerritoryCodes[countryCode];
        let cleanPhoneNumber = phoneNumber.replace(/\D/g, "");

        if (cleanPhoneNumber.startsWith(areaCode) || cleanPhoneNumber.startsWith("0" + areaCode)) {
          if (cleanPhoneNumber.charAt(0) === "0") {
            cleanPhoneNumber = cleanPhoneNumber.slice(1);
          }
          cleanPhoneNumber = cleanPhoneNumber.substring(areaCode.length);
        }

        this.phoneInformation.phoneNumber = cleanPhoneNumber;
        this.$nextTick(() => {
          const telInputUserRegisterRef = this.$refs["telInputUserRegisterRef"];
          const telInputComponent = Array.isArray(telInputUserRegisterRef) ? telInputUserRegisterRef[0] : telInputUserRegisterRef;
          if (currentPhoneNumber !== this.phoneInformation.phoneNumber) {
            this.restoreSelectedPhoneCountry(telInputComponent, this.phoneInformation, currentPhoneNumberCountryObject);
          }
        });
        return;
      }
      // Ülke formatını al
      const countryFormat = this.countryPhoneFormats[countryCode];

      // Eğer event varsa, değerini kontrol et; yoksa phoneNumber kullan
      const inputValue = event ? event.target.value : phoneNumber;

      // Eğer telefon numarası yeterli uzunluktaysa formatla
      if (inputValue.length >= (countryFormat?.minLength || 8)) {
        // Önce tüm formatları temizle (parantezler, boşluklar, çizgiler)
        let cleanPhoneNumber = phoneNumber.replace(/[\s\-()]/g, "");

        // Başındaki 0'ı kaldır (çoğu ülke formatında)
        if (cleanPhoneNumber.startsWith("0")) {
          cleanPhoneNumber = cleanPhoneNumber.slice(1);
        }

        // Ülkeye göre formatla
        if (countryFormat) {
          // Placeholder formatını kullanarak numarayı formatla
          const placeholder = countryFormat.placeholder;
          let formattedNumber = "";
          let numIndex = 0;

          // Placeholder'daki karakterleri tek tek kontrol et
          for (let i = 0; i < placeholder.length && numIndex < cleanPhoneNumber.length; i++) {
            const char = placeholder.charAt(i);

            if (char === "_") {
              // "_" yerine numarayı koy
              formattedNumber += cleanPhoneNumber.charAt(numIndex++);
            } else {
              // Boşluk veya özel karakter ise olduğu gibi ekle
              formattedNumber += char;
            }
          }

          // Eğer numara, placeholder'dan daha uzunsa kalan rakamları ekle
          if (numIndex < cleanPhoneNumber.length) {
            formattedNumber += cleanPhoneNumber.substring(numIndex);
          }

          // Başındaki 0'ı tekrar kontrol et ve kaldır
          if (formattedNumber.startsWith("0")) {
            formattedNumber = formattedNumber.replace(/^0/, "");
          }

          this.phoneInformation.phoneNumber = formattedNumber;
        } else {
          // Varsayılan Türkiye formatı (eğer ülke formatı bulunamadıysa)
          this.phoneInformation.phoneNumber = cleanPhoneNumber.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, "$1 $2 $3 $4");
        }
        // Ayirac karakterler (bosluk, tire, parantez) haric sadece hane sayisi ulke formatiyla karsilastirilir.
        const phoneFormat = this.countryPhoneFormats[this.phoneInformation.phoneNumberCountryObject.iso2];
        const digitCount = this.cleanPhoneNumber(this.phoneInformation?.phoneNumber).length;
        this.phoneInformation.isValid = phoneFormat
          ? digitCount >= phoneFormat.minLength && digitCount <= phoneFormat.maxLength
          : digitCount >= 10;
      } else {
        this.phoneInformation.isValid = false;
      }

      // başındaki 0'ı kaldırıyoruz
      this.$nextTick(() => {
        if (this.phoneInformation.phoneNumber && this.phoneInformation.phoneNumber.startsWith("0")) {
          this.phoneInformation.phoneNumber = this.phoneInformation.phoneNumber.replace(/^0/, "");
          const telInputUserRegisterRef = this.$refs["telInputUserRegisterRef"];
          const telInputComponent = Array.isArray(telInputUserRegisterRef) ? telInputUserRegisterRef[0] : telInputUserRegisterRef;
          if (currentPhoneNumber !== this.phoneInformation.phoneNumber) {
            this.restoreSelectedPhoneCountry(telInputComponent, this.phoneInformation, currentPhoneNumberCountryObject);
          }
        }
      });
    },
    handlePastePhoneNumberForPhoneNumber(event) {
      // Kullanıcının yapıştırdığı metin
      let phoneNumber = event.clipboardData.getData("text").trim();

      // İstenen karakterler dışındaki her şeyi temizle (yalnızca rakamlar, parantezler ve boşluklar)
      phoneNumber = phoneNumber.replace(/[^0-9()\s-]/g, "");

      if (phoneNumber.length === 0) {
        return;
      }

      const countryCode = this.phoneInformation.phoneNumberCountryObject.iso2 || "TR";

      // ABD teritorileri için özel işlem
      if (this.usTerritoryCodes[countryCode]) {
        const areaCode = this.usTerritoryCodes[countryCode];
        // Tüm formatlama karakterlerini temizle
        let cleanPhoneNumber = phoneNumber.replace(/[\s\-()]/g, "");

        // Alan kodu varsa kaldır
        if (cleanPhoneNumber.startsWith(areaCode)) {
          cleanPhoneNumber = cleanPhoneNumber.substring(areaCode.length);
        }

        // Telefon formatını uygula
        if (cleanPhoneNumber.length >= 7) {
          cleanPhoneNumber = cleanPhoneNumber.substring(0, 7);
          // Format (xxx-xxxx) uygula
          phoneNumber = cleanPhoneNumber.replace(/(\d{3})(\d{4})/, "$1-$2");
        } else {
          phoneNumber = cleanPhoneNumber;
        }

        // Maksimum uzunluğu ayarla
        const countryFormat = this.countryPhoneFormats[countryCode];
        if (countryFormat) {
          const placeholder = countryFormat.placeholder;
          const numberOfSpaces = (placeholder.match(/\s/g) || []).length;
          const dashCount = (placeholder.match(/\-/g) || []).length;
          this.phoneInformation.telInputOptions.maxlength = countryFormat.maxLength + numberOfSpaces + dashCount;
        } else {
          this.phoneInformation.telInputOptions.maxlength = 8; // xxx-xxxx
        }

        let currentPhoneNumberCountryObject = JSON.parse(JSON.stringify(this.phoneInformation.phoneNumberCountryObject));
        let currentPhoneNumber = this.phoneInformation.phoneNumber;

        this.$nextTick(() => {
          this.phoneInformation.phoneNumber = phoneNumber;
          const telInputUserRegisterRef = this.$refs["telInputUserRegisterRef"];
          const telInputComponent = Array.isArray(telInputUserRegisterRef) ? telInputUserRegisterRef[0] : telInputUserRegisterRef;
          if (currentPhoneNumber !== this.phoneInformation.phoneNumber) {
            this.restoreSelectedPhoneCountry(telInputComponent, this.phoneInformation, currentPhoneNumberCountryObject);
          }
        });
        return;
      }

      if (this.isGBTerritory(countryCode)) {
        let cleanNumber = this.cleanPhoneNumber(phoneNumber);

        // Başındaki 0'ları kaldır
        cleanNumber = cleanNumber.replace(/^0+/, "");
        const areaCode = this.gbTerritoryCodes[countryCode];
        if (cleanNumber.startsWith(areaCode)) {
          cleanNumber = cleanNumber.substring(areaCode.length);
        }
        const formattedNumber = cleanNumber.replace(/(\d{3})(\d{4})/, "$1-$2");
        let currentPhoneNumberCountryObject = JSON.parse(JSON.stringify(this.phoneInformation.phoneNumberCountryObject));
        let currentPhoneNumber = this.phoneInformation.phoneNumber;

        this.$nextTick(() => {
          this.phoneInformation.phoneNumber = formattedNumber;
          const telInputUserRegisterRef = this.$refs["telInputUserRegisterRef"];
          const telInputComponent = Array.isArray(telInputUserRegisterRef) ? telInputUserRegisterRef[0] : telInputUserRegisterRef;
          if (currentPhoneNumber !== this.phoneInformation.phoneNumber) {
            this.restoreSelectedPhoneCountry(telInputComponent, this.phoneInformation, currentPhoneNumberCountryObject);
          }
        });
        return;
      }

      // Özel formatlama için önce parantezleri ve tireleri kaldırıp sadece rakamları alalım
      let digitsOnly = phoneNumber.replace(/[^0-9]/g, "");

      // Başlangıçtaki sıfırları kaldıralım
      digitsOnly = digitsOnly.replace(/^0+/, "");

      // Formatlama - Türkiye standardına göre telefon numarası formatı: XXX XXX XX XX
      let formattedNumber = "";
      const digitLength = digitsOnly.length;

      if (digitLength >= 10) {
        // 10 haneli numara için (standart TR formatı)
        formattedNumber = digitsOnly.substring(0, 3) + " " + digitsOnly.substring(3, 6) + " " + digitsOnly.substring(6, 8) + " " + digitsOnly.substring(8, 10);
      } else if (digitLength >= 8) {
        // 8-9 haneli numaralar için
        formattedNumber = digitsOnly.substring(0, 3) + " " + digitsOnly.substring(3, 6) + " " + digitsOnly.substring(6, digitLength);
      } else if (digitLength >= 6) {
        // 6-7 haneli numaralar için
        formattedNumber = digitsOnly.substring(0, 3) + " " + digitsOnly.substring(3, digitLength);
      } else {
        // 5 veya daha az haneli numaralar için
        formattedNumber = digitsOnly;
      }

      // Maksimum uzunluğu ayarlama
      if (formattedNumber.length > this.phoneInformation.telInputOptions.maxlength) {
        formattedNumber = formattedNumber.slice(0, this.phoneInformation.telInputOptions.maxlength);
      }

      // Ülke koduna göre maxlength ayarlama
      if (this.phoneInformation.phoneNumberCountryObject && this.phoneInformation.phoneNumberCountryObject.iso2 === "TR") {
        this.phoneInformation.telInputOptions.maxlength = 13;
      } else {
        const numberOfSpaces = (this.phoneInformation.telInputOptions.placeholder.match(/\s/g) || []).length;
        const dashCount = (this.phoneInformation.telInputOptions.placeholder.match(/-/g) || []).length;
        this.phoneInformation.telInputOptions.maxlength =
          this.countryPhoneFormats[this.phoneInformation.phoneNumberCountryObject?.iso2]?.maxLength + numberOfSpaces + dashCount ?? 15;
      }

      this.phoneInformation.phoneNumber = "";
      let currentPhoneNumberCountryObject = JSON.parse(JSON.stringify(this.phoneInformation.phoneNumberCountryObject));
      let currentPhoneNumber = this.phoneInformation.phoneNumber;
      this.$nextTick(() => {
        this.phoneInformation.phoneNumber = formattedNumber;
        const telInputUserRegisterRef = this.$refs["telInputUserRegisterRef"];
        const telInputComponent = Array.isArray(telInputUserRegisterRef) ? telInputUserRegisterRef[0] : telInputUserRegisterRef;
        if (currentPhoneNumber !== this.phoneInformation.phoneNumber) {
          this.restoreSelectedPhoneCountry(telInputComponent, this.phoneInformation, currentPhoneNumberCountryObject);
        }
      });
    },
    onDropdownOpen() {
      let vm = this;
      // select picker açık ise tel input dropdonw kapaması için
      $(".selectpicker").on("show.bs.select", function () {
        vm.$refs.telInputUserRegisterRef.open = false;
      });
    },
    checkMernisDispatchResponse() {
      return new Promise((resolve, reject) => {
        if (this.isIndividualCustomer) {
          let mernisReq = {};
          mernisReq.identifyNumber = this.selectedUser.user.citizenshipNo;
          mernisReq.name = this.selectedUser.user.firstName;
          mernisReq.surname = this.selectedUser.user.lastName;
          mernisReq.gender = this.selectedUser.user.gender;
          let birthDate = this.selectedUser.user.birthdate;
          let [day, month, year] = birthDate.split(".");
          mernisReq.birthDate = `${year}${month}${day}`;
          this.loadingCheckMernis = true;
          this.$store
            .dispatch("checkMernis", mernisReq)
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              this.callAlert(
                4,
                this.$t("user-register-we-cannot-process-your-transaction-at-this-time-please-try-again-later"),
                "warning",
                this.$t("user-register-transaction-alert")
              );
            })
            .finally(() => {
              this.loadingCheckMernis = false;
            });
        }
      });
    },
    createCustomer() {
      //note: "üye ol" tıklandığında, modal içerisindeki verilerin sıfırlanması ve validasyonun resetlenmesi baseheader'da yapıldı.

      // Kayit Ol'a basildi: telefon zorunlu/gecersiz uyarisi artik gosterilebilir.
      this.phoneValidationTriggered = true;
      this.$refs.register.validate().then(async (success) => {
        if (success) {
          let isMernisValid = true;
          let isIndividualCustomerRequest = {
            bloodType: {},
            profession: {},
            user: {},
            educationStatus: {},
          };
          let corporateCustomerRequest = {
            user: { taxAdministration: {} },
          };
          if (this.isIndividualCustomer) {
            isIndividualCustomerRequest.user.nationalityCountryId = this.selectedUser.user.nationalityCountryId;
            if (this.selectedUser.user.citizenshipNo) {
              isIndividualCustomerRequest.user.citizenshipNo = this.selectedUser.user.citizenshipNo;
              isIndividualCustomerRequest.user.nationalityCountryId = 1;
            } else {
              isIndividualCustomerRequest.user.passportNo = this.selectedUser.user.passportNo;
              isIndividualCustomerRequest.user.nationalityCountryId = 0;
            }
            isIndividualCustomerRequest.user.firstName = this.selectedUser.user.firstName;
            isIndividualCustomerRequest.user.lastName = this.selectedUser.user.lastName;
            isIndividualCustomerRequest.user.gender = this.selectedUser.user.gender;
            let parts = this.selectedUser.user.birthdate.split(".");
            let day = parts[0];
            let month = parts[1];
            let year = parts[2];
            isIndividualCustomerRequest.user.birthdate = year + "-" + month + "-" + day;
            isIndividualCustomerRequest.bloodType = this.selectedUser.bloodType;
            isIndividualCustomerRequest.profession = this.selectedUser.profession;
            isIndividualCustomerRequest.educationStatus = this.selectedUser.educationStatus;
            isIndividualCustomerRequest.user.enrollmentNo = this.selectedUser.user.enrollmentNo;
            isIndividualCustomerRequest.image = this.itemImage;
          } else {
            // kurumsal
            corporateCustomerRequest.user.companyName = this.selectedUser.user.companyName;
            corporateCustomerRequest.user.taxAdministration = this.selectedUser.user.taxAdministration;
            corporateCustomerRequest.user.taxNo = this.selectedUser.user.taxNo;
          }

          let request = isIndividualCustomerRequest;
          if (this.isIndividualCustomer) {
            request = isIndividualCustomerRequest;
          } else {
            request = corporateCustomerRequest;
          }

          // common
          request.id = this.selectedUser.id ? this.selectedUser.id : undefined;
          request.user.id = this.selectedUser.user.id ? this.selectedUser.user.id : undefined;
          request.user.keycloakId = this.selectedUser.user.keycloakId ? this.selectedUser.user.keycloakId : undefined;
          request.user.email = this.selectedUser.user.email;
          request.user.mobileNumber = this.phoneInformation.phoneNumber;

          // Numarayı temizliyoruz
          request.user.mobileNumber = request.user.mobileNumber.replace(/\D/g, "");

          // Eğer kullanıcının ISO2 kodu ABD teritorilerinden biriyse
          if (this.usTerritoryCodes[this.phoneInformation.phoneNumberCountryObject.iso2]) {
            // Başına alan kodunu ekleyelim
            const areaCode = this.usTerritoryCodes[this.phoneInformation.phoneNumberCountryObject.iso2];

            // Eğer alan kodu zaten ekli değilse ekleyelim
            if (!request.user.mobileNumber.startsWith(areaCode)) {
              request.user.mobileNumber = areaCode + request.user.mobileNumber;
            }
          } else if (this.gbTerritoryCodes[this.phoneInformation.phoneNumberCountryObject.iso2]) {
            // Başına alan kodunu ekleyelim
            const areaCode = this.gbTerritoryCodes[this.phoneInformation.phoneNumberCountryObject.iso2];

            // Eğer alan kodu zaten ekli değilse ekleyelim
            if (!request.user.mobileNumber.startsWith(areaCode)) {
              request.user.mobileNumber = areaCode + request.user.mobileNumber;
            }
          }

          // Ülke kodunu atayalım
          request.user.mobileNumberCountryCode = this.phoneInformation.phoneNumberCountryObject.dialCode;
          this.identityRules();
          request.cityId = this.selectedUser.cityId;
          request.districtId = this.selectedUser.districtId;
          request.neighbourhoodId = this.selectedUser.neighbourhoodId;
          request.address = this.selectedUser.address;
          request.permissionMarketingEmail = this.selectedUser.permissionMarketingEmail;
          request.permissionMarketingSms = this.selectedUser.permissionMarketingSms;
          request.hasLoyalty = this.selectedUser.hasLoyalty;
          request.user.status = this.selectedStatus;
          request.user.statusReason = { id: this.selectedStatusReason };
          request.user.statusReasonDescription = this.statusReasonDescription;
          request.user.type = "CUSTOMER";
          request.company = !this.isIndividualCustomer;

          if (this.selectedUser.user.status === "ACTIVE") {
            this.selectedStatusReason = 5;
          }

          // boş geliyorsa request içerisinden kaldır start
          if (this.selectedUser.bloodType.id === undefined || this.selectedUser.bloodType.id === null) {
            delete request.bloodType;
          }
          if (this.selectedUser.educationStatus.id === undefined || this.selectedUser.educationStatus.id === null) {
            delete request.educationStatus;
          }
          if (this.selectedStatusReason === undefined || this.selectedStatusReason === null) {
            delete request.user.statusReason;
          }
          // boş geliyorsa request içerisinden kaldır end

          let userSaveOrUpdateType = "saveCustomerInformation";
          if (this.selectedUser.id) userSaveOrUpdateType = "updateCustomerInformation";
          this.createLoading = true;
          try {
            if (this.isIndividualCustomer && this.selectedUser.user.citizenshipNo) {
              isMernisValid = await this.checkMernisDispatchResponse();
            }
            if (isMernisValid === false && this.isIndividualCustomer && this.selectedUser.user.citizenshipNo) {
              this.callAlert(
                4,
                this.$t("user-register-mernis-verification-failed-please-check-your-information"),
                "warning",
                this.$t("user-register-transaction-alert")
              );
              this.createLoading = false;
            } else {
              this.$store
                .dispatch(userSaveOrUpdateType, request)
                .then((response) => {
                  if (response.status !== 200) {
                    if (response.data.message === null) {
                      this.callAlert(4, this.$t("failed-transaction-v3"), "danger", this.$t("failed-transaction-title-v2"));
                      return;
                    } else {
                      this.callAlert(4, response.data.message, "danger", this.$t("failed-transaction-title-v2"));
                      return;
                    }
                  }
                  if (response.status === 200 || response.status === 204) {
                    this.$store.commit("setIsThisAnUpdateCustomer", false);
                  }
                  // if(userSaveOrUpdateType === 'saveCustomerInformation'){
                  //   this.resetPassword();
                  // }
                  // this.resetCustomer()
                  $("#newUser").modal("hide");
                  this.callAlert(5, this.$t("user-register-signed-up-success-text"), "success", this.$t("user-register-signed-up-success-title"));
                })
                .catch((err) => {
                  this.callAlert(4, this.$t("failed-transaction-v3"), "danger", this.$t("failed-transaction-title-v2"));
                })
                .finally(() => {
                  this.createLoading = false;
                });
            }
          } catch (error) {
            console.error("Hata:", error);
          } finally {
            this.createLoading = false;
          }
        } else {
          this.callAlert(4, this.$t("my-registered-passenger-fill-required-field"), "danger", this.$t("user-register-transaction-alert"));
        }
      });
    },
    imageUpload() {
      if (this.uploadImageFlag === false) return;
      if (this.itemImage === null || this.$refs.imaging.imageSizeControl() === false) return;
      let request = {};
      request.image = this.itemImage;
      request.name = "ditravoimg" + Math.floor(Math.random() * 1000 + new Date().getUTCMilliseconds());
      this.$store.dispatch("uploadImage", request).then((response) => {
        this.selectedUser.image = response.data;
      });
    },
    identityRulesMessage(nationalityCountryId) {
      if (nationalityCountryId === 1) {
        return { required: this.$t("required-field"), length: this.$t("user-register-tck-no-length-warning") };
      } else {
        return {
          required: this.$t("user-register-passport-field-is-required-to-be-filled"),
          min: this.$t("user-register-passport-no-length-warning"),
          max: this.$t("user-register-passport-no-length-warning-2"),
        };
      }
    },
    identityRules(nationalityCountryId) {
      if (nationalityCountryId === 1) {
        return { required: true, length: 11 };
      } else {
        return { required: true, min: 5, max: 11 };
      }
    },
    nationalityChanged(event) {
      const value = event.target.checked ? 0 : 1;
      if (value === 1) {
        this.isTurkish = true;
        this.selectedUser.user.nationalityCountryId = 1;
        delete this.selectedUser.user.passportNo;
        this.$refs.citizenshipNo.resetValidation();
        this.$refs.passportNo.resetValidation();
      } else if (value !== 1) {
        this.isTurkish = false;
        this.selectedUser.user.nationalityCountryId = 0;
        delete this.selectedUser.user.citizenshipNo;
        this.$refs.citizenshipNo.resetValidation();
        this.$refs.passportNo.resetValidation();
      }
    },
    changeCity(event) {
      const value = parseInt(event.target.value);
      this.selectedUser.districtId = "";
      this.loadingDistricts = true;
      this.$store
        .dispatch("loadDistricts", { id: value })
        .then((response) => {
          this.districts = response;
        })
        .finally(() => {
          $(".selectpicker").selectpicker("refresh");
          this.loadingDistricts = false;
        });
      this.neighbourhoods = [];
    },
    changeDistrict(event) {
      const value = parseInt(event.target.value);
      this.selectedUser.neighbourhoodId = "";
      if (value === undefined || value === null || value === "") return;
      this.loadingNeighbourhoods = true;
      this.$store
        .dispatch("loadNeighbourhoods", { id: value })
        .then((response) => {
          this.neighbourhoods = response;
        })
        .finally(() => {
          $(".selectpicker").selectpicker("refresh");
          this.loadingNeighbourhoods = false;
          this.$nextTick(() => {
            if (!this.isThisAnUpdateCustomer) {
              this.selectedUser.neighbourhoodId = value;
            }
          });
        });
    },
    removeEmailValidation(event) {
      if (event.target.checked) {
        this.emailRequired = false;
      } else {
        this.emailRequired = true;
      }
    },
    validationTextFormat(text) {
      if (text === null || text === undefined) {
        return "";
      }
      let fiterText = text.split(" ");
      let returnText = fiterText[0];
      for (let i = 1; i < fiterText.length; i++) {
        returnText += " " + fiterText[i].charAt(0).replace(/İ/gim, "i").toLowerCase() + fiterText[i].slice(1).toLowerCase();
      }
      return returnText;
    },
    changeCustomerType(event) {
      setTimeout(() => {
        $(".selectpicker").selectpicker("refresh");
      });
    },
    resetCustomer() {
      this.$store.commit("setIsThisAnUpdateCustomer", false);
      this.selectedUser = {
        bloodType: {},
        profession: { id: "" },
        user: { taxAdministration: {} },
        educationStatus: {},
      };
      this.phoneInformation.phoneNumber = "";
      this.selectedUser.cityId = "";
      this.selectedUser.districtId = "";
      this.selectedUser.neighbourhoodId = "";
      this.selectedUser.bloodType.id = "";
      this.selectedUser.profession.id = "";
      this.selectedUser.educationStatus.id = "";
      this.selectedUser.user.taxAdministration.id = "";
      this.selectedUser.user.gender = "";
      this.selectedUser.user.nationalityCountryId = 1;
      this.itemImage = null;
      this.inputPassword = null;
      this.reInputPassword = null;
      this.selectedUser.birthdate = "";
      this.selectedStatus = "PASSIVE";
      this.$refs.register.reset();
      this.$nextTick(() => {
        $(".selectpicker").selectpicker("refresh");
      });
    },
    resetPassword() {
      let resetPasswordReq = {};
      resetPasswordReq.username = this.selectedUser.user.email;
      resetPasswordReq.sendEmail = false;
      this.loadingResetPassword = true;
      this.$store
        .dispatch("resetPasswordGenerateCode", resetPasswordReq)
        .then((restRes) => {
          if (!restRes) {
            this.callAlert(4, resetLink, "danger", this.$t("user-register-incorrect-request"), "danger");
            return;
          }
          let resetLink = window.location.origin + "/sifre-sifirla?url=" + restRes.code;
          this.callAlert(30, resetLink, "success", this.$t("user-register-copy-it-for-the-new-password"), "success");
        })
        .finally(() => {
          this.loadingResetPassword = false;
        });
    },
    isPhoneNumberRequired() {
      let findNationality = this.nationalityList.find((nationality) => nationality.id === this.selectedUser.user.nationalityCountryId);
      if (!!findNationality && findNationality.code === "TR") {
        return { required: true, is: !this.phoneInformation.isValid, min: 2 };
      } else {
        return { required: false, is: !this.phoneInformation.isValid };
      }
    },
    regexControl(letter, event) {
      if (letter === "passportNo") {
        let passengerPassport = this.selectedUser.user.passportNo;
        let inputValue = event.target.value;
        const cursorPosition = event.target.selectionStart;

        // Başındaki boşlukları temizle ve fazla boşlukları tek boşlukla değiştir
        passengerPassport = passengerPassport.trimStart().replace(/\s+/g, " ");
        inputValue = inputValue.trimStart().replace(/\s+/g, " ");

        // Geçersiz karakterleri temizle
        const invalidChars = /[^\w\sğüşıöçĞÜŞİÖÇ]/g;
        passengerPassport = passengerPassport.replace(invalidChars, "");
        inputValue = inputValue.replace(invalidChars, "");

        // Büyük harfe dönüştür
        const locale = "tr-TR";
        passengerPassport = passengerPassport.toLocaleUpperCase(locale);
        inputValue = inputValue.toLocaleUpperCase(locale);

        // İşlenmiş değerleri geri ata
        this.selectedUser.user.passportNo = passengerPassport;
        event.target.value = inputValue;

        // Cursor pozisyonunu geri yükle
        this.$nextTick(() => {
          event.target.setSelectionRange(cursorPosition, cursorPosition);
        });
      }
    },
    openMemberLogin() {
      $("#newUser").modal("hide");
      if (!this.isMobileDropdownMenu) {
        this.$parent.$refs.sidebarBackdropRef.hide();
      }
      setTimeout(() => {
        if (this.isMobileDropdownMenu) {
          $("#dropDownSideBar").dropdown("show");
        } else {
          $("#btnLogin").dropdown("show");
        }
      });
    },
    fixedNumberProblemForUSTerritoriesForPhoneNumber(phoneNumber, countryCode) {
      // Eğer ABD territorisi ise özel işlem uygula
      if (this.usTerritoryCodes[countryCode]) {
        const areaCode = this.usTerritoryCodes[countryCode];
        // Tüm formatlama karakterlerini temizle
        let cleanPhoneNumber = phoneNumber.replace(/[\s\-()]/g, "");

        // Alan kodu varsa kaldır
        if (cleanPhoneNumber.startsWith(areaCode)) {
          cleanPhoneNumber = cleanPhoneNumber.substring(areaCode.length);
        }

        // Telefon formatını uygula
        const countryFormat = this.countryPhoneFormats[countryCode];
        if (countryFormat && cleanPhoneNumber.length >= countryFormat.minLength) {
          cleanPhoneNumber = cleanPhoneNumber.substring(0, countryFormat.maxLength);
          // Format (xxx-xxxx) uygula
          this.phoneInformation.phoneNumber = cleanPhoneNumber.replace(/(\d{3})(\d{4})/, "$1-$2");
          this.phoneInformation.isValid = true;
        } else {
          this.phoneInformation.phoneNumber = cleanPhoneNumber;
        }
        return true;
      }
      return false;
    },
    checkPhoneValidation() {
      // dropdown açık ise validasyona girmeyecek.
      if (!this.$refs.telInputUserRegisterRef.$refs.list) {
        let isRegexValidate = this.checkIsRegexValidate();
        if (this.phoneInformation.phoneNumber.length > 0 && isRegexValidate) {
          this.phoneInformation.isValid = true;
          return true;
        } else {
          this.phoneInformation.isValid = false;
          return false;
        }
      }
    },
    checkIsRegexValidate() {
      const countryCode = this.phoneInformation.phoneNumberCountryObject.iso2;
      const isTR = countryCode === "TR";
      const trRegex = /^0?\d{3}\s\d{3}\s\d{2}\s\d{2}$|^\d{3}\s\d{2}\s\d{2}\s\d{2}$|^\d{10}$/;

      // ABD teritorisi kontrolü
      const isUSTerritory = this.isUSTerritory(countryCode);
      const isGBTerritory = this.isGBTerritory(countryCode);

      // ABD teritorileri için özel regex
      let usTerritoryRegex;
      if (isUSTerritory) {
        // Alan kodu + 7 haneli numara (xxx-xxxx formatı) veya sadece 7 haneli numara
        usTerritoryRegex = new RegExp(`^(${this.usTerritoryCodes[countryCode]})?\\d{3}-\\d{4}$|^\\d{3}-\\d{4}$|^\\d{7}$`);
      }

      let gbTerritoryRegex;
      if (isGBTerritory) {
        gbTerritoryRegex = new RegExp(
          "^[\\d\\s]{10,12}$" // 10 veya 12 haneli numara
        );
      }
      // Non-TR ülkeleri için placeholder bazlı regex oluşturma
      let nonTRRegex;
      if (!isTR && !isUSTerritory && !isGBTerritory && this.countryPhoneFormats[countryCode]) {
        const format = this.countryPhoneFormats[countryCode];

        // Temel digit sayısı (sadece rakamlar)
        const digitCount = (format.placeholder.match(/_/g) || []).length;

        // İki farklı regex hazırlayalım: Düz rakamlar için ve formatlı giriş için
        let plainDigitsRegex = `^\\d{${format.minLength},${format.maxLength}}$`;

        // Eğer placeholder varsa ve özel format içeriyorsa (boşluk, tire vs.)
        let formattedRegex = null;
        if (format.placeholder) {
          // Placeholder'ı regex pattern'e çevirelim
          let pattern = "";
          let digitCounter = 0;

          for (let i = 0; i < format.placeholder.length; i++) {
            if (format.placeholder[i] === "_") {
              pattern += "\\d";
              digitCounter++;
            } else if (format.placeholder[i] === " ") {
              pattern += "\\s";
            } else if (format.placeholder[i] === "-") {
              pattern += "\\-";
            } else if (format.placeholder[i] === "(") {
              pattern += "\\("; // Parantez escape edildi
            } else if (format.placeholder[i] === ")") {
              pattern += "\\)"; // Parantez escape edildi
            } else {
              pattern += format.placeholder[i];
            }
          }

          formattedRegex = `^${pattern}$`;
        }
        // İki regex'i birleştirelim: Ya düz rakamlar (formatsız) ya da formatlı olabilir
        if (formattedRegex) {
          nonTRRegex = new RegExp(`${formattedRegex}|${plainDigitsRegex}`);
        } else {
          nonTRRegex = new RegExp(plainDigitsRegex);
        }
      }

      if (isTR) {
        return trRegex.test(this.phoneInformation.phoneNumber);
      } else if (isUSTerritory) {
        return usTerritoryRegex.test(this.phoneInformation.phoneNumber);
      } else if (isGBTerritory) {
        return gbTerritoryRegex.test(this.phoneInformation.phoneNumber);
      } else {
        return nonTRRegex.test(this.phoneInformation.phoneNumber);
      }
    },
    checkTelInputRef() {
      this.$nextTick(() => {
        if (this.$refs.telInputUserRegisterRef && this.$refs.telInputUserRegisterRef.finishMounted) {
          this.phoneInformation.isValid = true;
        } else {
          setTimeout(() => {
            this.checkTelInputRef();
          }, 100);
        }
      });
    },
    checkMobileDropdownMenu() {
      this.isMobileDropdownMenu = window.innerWidth <= 576;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .selectedItemIsValid {
    .btn {
      &.dropdown-toggle {
        border-color: #28a745 !important;
      }
    }
  }
}

.passwordUpdate {
  ::v-deep {
    .passportNoField.error {
      margin-bottom: 30px !important;
    }
    .form-control:disabled,
    .form-control[readonly] {
      opacity: 0.5;
    }
    .customTelInput.vue-tel-input {
      height: calc(2em + 1rem + 2px);
    }
    .customTelInput.vue-tel-input .vti__input {
      height: 44px !important;
      background-position: calc(100% - 14px) center;
    }
  }
}
.rightHandModal .modal-dialog .modal-content .modal-body .modalText {
  font-size: 12px;
}
.userRegisterPassengerCheckBox {
  box-shadow: none !important;
  outline: none !important;
  .checkboxArea {
    box-shadow: none !important;
    outline: none !important;
    padding-left: 46px;
    padding-right: 16px;
    padding-top: 0px;
    padding-bottom: 0px;
    border: solid 1px var(--light-blue-grey);
    background-color: #fafafa;
    border-radius: 12px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: calc(2.5em + 15px);
    .checkboxText {
      font-size: 14px;
      font-weight: 600;
      color: var(--dusk);
      line-height: 1.4;
      padding: 0px;
    }
    .checkmark {
      margin-left: 16px;
      top: 50%;
      margin-top: -10px;
    }
  }
}

.user-register-birthdate-wrapper {
  gap: 8px;
}

.date-icon-wrapper {
  position: relative;
  width: 50px;
  height: 50px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--light-blue-grey);
  border-radius: 12px;
  background-color: #fafafa;
  flex: 0 0 44px;
}

.date-icon-wrapper i {
  pointer-events: none;
}

.date-hidden-input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
</style>
